module.exports = __webpack_public_path__ + "static/TheMarketplacs_3320x1002-6eccd56d5d0aa0a4c4b67039b72c393c.png";